module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "nav has-shadow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('div', {
    staticClass: "nav-item"
  }, [_vm._v("#" + _vm._s(_vm.count) + " - 표준편차 " + _vm._s(_vm.groups.length ? _vm.groups.stddev : '0'))])]), _c('div', {
    staticClass: "nav-right"
  }, [_c('a', {
    staticClass: "nav-item"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.totoro),
      expression: "totoro"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.totoro) ? _vm._i(_vm.totoro, null) > -1 : (_vm.totoro)
    },
    on: {
      "change": _vm.toggleTotoro,
      "__c": function($event) {
        var $$a = _vm.totoro,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.totoro = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.totoro = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.totoro = $$c
        }
      }
    }
  }), _vm._v("배경")])]), _c('a', {
    staticClass: "nav-item"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grade),
      expression: "grade"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.grade) ? _vm._i(_vm.grade, null) > -1 : (_vm.grade)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.grade,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.grade = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.grade = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grade = $$c
        }
      }
    }
  }), _vm._v("성적")])])])])]), _c('section', {
    staticClass: "section",
    class: _vm.totoro ? "totoro" : ""
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('transition-group', {
    staticClass: "columns is-multiline",
    attrs: {
      "name": "result-group"
    }
  }, _vm._l((_vm.groups), function(g, index) {
    return _c('group', {
      key: index,
      attrs: {
        "index": index,
        "group": g,
        "show": _vm.grade
      }
    })
  }))], 1), _c('div', {
    staticClass: "column is-one-third"
  }, [_c('dashboard', {
    attrs: {
      "students": _vm.students,
      "show": _vm.grade
    },
    on: {
      "add": _vm.addStudent,
      "remove": _vm.removeStudent,
      "import": _vm.importFile,
      "start": _vm.makeGroup
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-b4ebf578"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./app/App.vue
// module id = 330
// module chunks = 0